const INIT_STATE = {
  loading: false,
  error: false,
  errorMessage: null,
	list: [],
	item: null,
	action: null
};

const reducer = (state = INIT_STATE, action) => {
	switch (action.type) {
		case 'GET_ORDERS':
			return { ...state, loading: true, error: false, errorMessage: null, action: null };

		case 'GET_ORDERS_SUCCESS':
			return { ...state, loading: false, error: false, errorMessage: null, list: action.payload.data, action: null };

		case 'GET_ORDERS_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'GET_ORDER':
			return { ...state, loading: true, error: false, action: null };

		case 'GET_ORDER_SUCCESS':
			return { ...state, loading: false, error: false, item: action.payload.data, action: null };

		case 'GET_ORDER_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'CREATE_ORDER':
			return { ...state, loading: true, error: false, action: null }

		case 'CREATE_ORDER_SUCCESS':
			return { ...state, loading: false, error: false, action: 'CREATED' }

		case 'CREATE_ORDER_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'UPDATE_ORDER':
			return { ...state, loading: true, error: false, action: null }

		case 'UPDATE_ORDER_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED' }

		case 'UPDATE_ORDER_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'DELETE_ORDER':
			return { ...state, loading: true, action: null }

		case 'DELETE_ORDER_SUCCESS':
			return { ...state, loading: false, error: false, action: 'DELETED' }

		case 'DELETE_ORDER_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'FINISH_ORDER':
			return { ...state, loading: true, action: null }

		case 'FINISH_ORDER_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED' }

		case 'FINISH_ORDER_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'CANCEL_ORDER':
			return { ...state, loading: true, action: null }

		case 'CANCEL_ORDER_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED' }

		case 'CANCEL_ORDER_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'CALCULATE_ORDER':
			return { ...state, loading: true, action: null }

		case 'CALCULATE_ORDER_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED' }

		case 'CALCULATE_ORDER_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		default:
			return state;

	}
};

export default reducer;